<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-9">
          <div class="h4">熱門標籤管理</div>
          <span class="text-danger">*同一時段最多顯示10個標籤，若超過則隨機抓取顯示</span>
        </div>
        <div class="col-3 d-flex flex-row-reverse">
          <button class="btn btn-primary btn-size"
                  @click="createHotTag()">新增</button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="mt-2 d-flex w-100">
        <div style="width: calc(100% - 200px)">
          <input class="form-control w-100 mb-2" v-model="search.tag" placeholder="輸入標籤關鍵字">
        </div>
        <div class="d-flex align-items-end ml-3">
          <button class="btn btn-primary" @click="searchByQuery(getHotTagList, {page: 1, ...search})">搜尋標籤</button>
          <button class="btn btn-danger" @click="resetSearch">重設搜尋</button>
        </div>
      </div>
      <div class="mt-2 d-flex flex-wrap flex-md-nowrap justify-content-end">
        <div class="text-secondary align-self-center" id="resultCount">
          共<span class="mr-1 ml-1">{{ totalData }}</span>筆
        </div>
        <div class="ml-2" style="width: 100px">
          <select class="form-control" v-model="search.state" @change="searchByQuery(getHotTagList, {page: 1, ...search})">
            <option :value="Const().ACTIVE">啟用中</option>
            <option :value="Const().ARCHIVED">已結束</option>
          </select>
        </div>
      </div>
      <div class="table-outter wrapper">
        <table v-if="currentPageDataList.length > 0" id="dataTable" class="table table-hover table-responsive vertical-middle text-center mt-4">
          <thead>
          <tr>
            <th scope="col" class="col-100" width="15%">標籤</th>
            <th scope="col" class="col-75" v-if="search.state == Const().ACTIVE">顯示中</th>
            <th scope="col" class="col-75" width="30%">起始時間</th>
            <th scope="col" class="col-75" width="30%">結束時間</th>
            <th scope="col" class="col-50" :width="search.state == Const().ACTIVE? '5%' : '20%'">{{ search.state == Const().ACTIVE? '編輯' : '再次上架' }}</th>
            <th scope="col" class="col-50" v-if="search.state == Const().ACTIVE">排序</th>
            <th scope="col" class="col-50" width="5%">刪除</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="data in currentPageDataList">
            <tr :key="data.id">
              <td class="col-100">
                {{ data.name }}
              </td>
              <td class="col-75" v-if="search.state == Const().ACTIVE" >{{ data.active | activeString }}</td>
              <td class="col-75">{{ data.startTime | timeString('YYYY/MM/DD HH:mm')}}</td>
              <td class="col-75">{{ data.endTime | timeString('YYYY/MM/DD HH:mm')}}</td>
              <td class="col-50">
                <i class="ml-2 icon-edit pointIcon" @click="editHotTag(data)"></i>
              </td>
              <td class="col-50" v-if="search.state == Const().ACTIVE" >
                <a class="d-block pointIcon" @click="moveUpItem(type, data, updateOrder, reOrderList, getHotTagList)">
                  <i class="font-weight-bold icon-chevron-up" ></i>
                </a>
                <a class="d-block pointIcon" @click="moveDownItem(type, data, updateOrder, reOrderList, getHotTagList)">
                  <i class="font-weight-bold icon-chevron-down"></i>
                </a>
              </td>
              <td class="col-50">
                <i class="icon-trash-2 pointIcon" @click="deleteHotTag(data)"></i>
              </td>
            </tr>

          </template>
          </tbody>
        </table>
        <div v-else id="result-hint" class="d-flex justify-content-center">
          <template v-if="isEmptyList">尚無資料</template>
          <template v-else><loading/></template>
        </div>
      </div>
      <!-- Pagination -->
      <ul v-if="currentPageDataList.length > 0" class="pagination justify-content-center">
        <li class="page-item">
          <a class="page-link" @click="currentPage != 1 ? getPreviousPage(currentPage, getHotTagList):''"><i class="fa fa-angle-left"></i></a>
        </li>
        <template v-for="page in range">
          <li class="page-item" :class="{'active': page === currentPage}" :key="page">
            <a class="page-link" @click="currentPage != page ? toTargetPage(page, getHotTagList):''" style="cursor: default;">{{page}}</a>
          </li>
        </template>
        <li class="page-item">
          <a class="page-link" @click="currentPage != totalPage ? toNextPage(currentPage, totalPage, getHotTagList):''"><i class="fa fa-angle-right"></i></a>
        </li>
      </ul>
      <!-- end: Pagination -->
    </div>
  </div>
</template>

<script>
import Loading from "@/components/common/Loading";
import ModalList from "@/const/modal";
import { mapMutations } from "vuex";
import { utilMixin } from "@/mixins/utilMixin";
import { adminMixin } from "@/mixins/adminMixin";
import Const from "@/const/index";
import { findManualSelectedList } from "@/service/api/internal/admin/manualSelected";

export default {
  name: "HotTag",
  mixins: [utilMixin, adminMixin],
  components: {
    Loading
  },
  data(){
    return {
      type: 'tag',
      search:{
        tag: '',
        state: Const.ACTIVE
      }
    }
  },
  mounted(){
    this.initSearchParam()
    this.getHotTagList(this.currentPage)
  },
  methods: {
    ...mapMutations(['showModal']),
    Const(){
      return Const
    },
    initSearchParam(){
      let search = JSON.parse(JSON.stringify(this.search))
      this.search = this.initSearchData(search)
      if(!this.search.state){
        this.search.state= Const.ACTIVE
      }
    },
    async getHotTagList(page){
      let currentPage = this.checkPageValid(page, this.currentPage, this.totalPage)
      this.currentPage = currentPage
      let query = this.getSearchQuery(this.currentPage, this.show, this.search)
      let response = await findManualSelectedList(this.type, query)
      this.currentPageDataList = response.data
      this.totalPage = response.totalPage
      this.totalData = response.totalElement
      if(this.currentPageDataList.length == 0){
        this.isEmptyList = true
      }
    },
    resetSearch(){
      let state = this.search.state
      this.search = {}
      this.search.state = state
      this.search.tag = ""
      if(window.location.search) {
        this.searchByQuery(this.getHotTagList, {page: 1, ...this.search})
      }
    },
    createHotTag(){
      let type = this.type
      this.showModal({
        modalId: ModalList.MANUAL_SELECTED_MODAL,
        payload: { type, mode: 'create', execFunc: this.getHotTagList }
      })
    },
    editHotTag(item){
      let state = this.search.state
      let data = item
      if(state == Const.ARCHIVED){
        data = { name : item.name }
      }
      this.showManualSelectedModal(this.type, state, data, this.getHotTagList)
    },
    deleteHotTag(data){
      let type = this.type
      this.showModal({
        modalId: ModalList.MANUAL_SELECTED_DELETE_MODAL,
        payload: { type, ...data, execFunc: this.getHotTagList }
      })
    }
  }
}
</script>

<style scoped>

.pointIcon{
  cursor: pointer;
  color: rgb(24 135 255)
}

.table-outter {
  overflow-x: scroll;
}

.col-100 {
  min-width: 100px;
}

.col-75 {
  min-width: 75px;
}

.col-50 {
  min-width: 50px;
}

@media only screen and (max-width: 576px) {
  .btn-size {
    border-radius: 0.2rem !important;
    font-size: 11px !important;
    height: 30px !important;
    line-height: 28px !important;;
    padding: 0 14px !important;
  }
}

</style>
